/**
 * Helper function to get the detail from an error object.
 *
 * @param error The error object received.
 * @returns The detail from the error object.
 */
export const getErrorDetail = (error: {
  detail?: string;
  message?: string;
}): string | undefined => {
  let detail: string | undefined;

  // First, check if the error object already has a 'detail' property.
  if (error?.detail) {
    detail = error.detail;
  }
  // Otherwise, sometimes the error message is a JSON string that holds the detail.
  else if (error?.message) {
    try {
      const parsed = JSON.parse(error.message);
      if (parsed?.detail) {
        detail = parsed.detail;
      }
    } catch (parseError) {
      // If parsing fails, fall back to using the error message directly.
      detail = error.message;
    }
  }

  return detail;
};
